import axios from "axios";
import { create } from "zustand";

const addressStore = create((set) => ({
  userAddress: null,
  isLoading: true,

  fetchAllUserAddress: async () => {
    try {
      // Fetch user addresses
      const res = await axios.get("/fetch-all-users-addresses");

      // set user address to state
      if (res.data.userAddress && res.data.userAddress.length) {
        set({ userAddress: res.data.userAddress });
      } else {
        set({ userAddress: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },
}));

export default addressStore;
